import { DatasetExploreItem } from "@/types/dataset";

import { twMerge } from "tailwind-merge";

type DatasetCardHeaderProps = {
  data: DatasetExploreItem;
  active?: boolean;
  showLogo?: boolean;
  rightIcon?: React.ReactNode;
  titleClassName?: string;
};

export const DatasetCardHeader = ({
  data,
  active,
  showLogo,
  rightIcon,
  titleClassName
}: DatasetCardHeaderProps) => {
  return (
    <div className="flex items-center justify-between shrink-0">
      <div className="flex gap-2 items-center">
        {showLogo && (
          <div className="h-10 w-10 border rounded-lg flex items-center justify-center bg-white">
            {data?.provider?.logo_asset_url ? (
              <img
                src={data?.provider?.logo_asset_url}
                alt={`logo-${data.source}`}
                className="h-8 w-8"
              />
            ) : null}
          </div>
        )}
        <div className="flex items-start flex-col gap-1 flex-1 min-w-0">
          <p
            className={twMerge(
              "text-sm text-txtHeading font-bold truncate",
              active && "text-teal-500",
              titleClassName
            )}
            title={data.name}
          >
            {data.name}
          </p>
          <p className="text-[10px] truncate" title={data.short_description}>
            {data.short_description}
          </p>
        </div>
      </div>
      {rightIcon}
    </div>
  );
};
